import { ReactQueryV5 } from "@mindlercare/mindlerapi-client";
const { useQuery } = ReactQueryV5;
import { CreateTransient, Icon } from "@mindlercare/ui-web";
import { Typography } from "components/typography";
import { useMindlerApi } from "api/apiv2";
import { useTranslation } from "react-i18next";
import { styled } from "styled-components";
import PatientItem from "../patientItem";
import { SharedProps } from "./types";
import { useMedicoreEnabled } from "./useMedicoreEnabled";

export const VerificationStatus = ({ patientUserId }: SharedProps) => {
  const { t } = useTranslation();
  const mindlerApi = useMindlerApi();
  const enabled = useMedicoreEnabled(patientUserId);
  const { data } = useQuery(
    mindlerApi.medicore.getMedicorePatientByPatientUserId.queryOptions(
      {
        patientUserId: Number(patientUserId),
      },
      {
        enabled,
      },
    ),
  );

  if (!enabled) {
    return null;
  }

  return (
    <PatientItem title={t("MEDICORE.ID_VERIFICATION_TITLE")}>
      <FlexHorizontal>
        <VerifiedIcon $isVerified={data?.verified} />
        <Typography variant="body">
          {data?.verified
            ? t("MEDICORE.ID_VERIFIED")
            : t("MEDICORE.ID_NOT_VERIFIED")}
        </Typography>
      </FlexHorizontal>
    </PatientItem>
  );
};

const FlexHorizontal = styled.div`
  display: flex;
  align-items: center;
  gap: ${(props) => props.theme.SPACING.SM};
`;

const VerifiedIcon = styled(Icon.Verified)<
  CreateTransient<{ isVerified?: boolean }>
>`
  color: ${({ theme, $isVerified }) =>
    $isVerified ? theme.COLORS.BLUE_DARK : theme.COLORS.ERROR};
`;
